<template>
  <div class="col-lg-4">
    <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-home"></i></span>
            <div class="media-body">
              <h3>Sanibands Gbr</h3>
              Friedrichstr. 123<br/>
              10117, Berlin, Germany<br/>
            </div>
          </div>
    <div class="media contact-info">
      <span class="contact-info__icon"><i class="ti-email"></i></span>
      <div class="media-body">
        <h3><a v-on:click="trackClick" href="mailto:info@sanitizerwristbands.com">info@sanitizerwristbands.com</a></h3>
        <p>Send us your query anytime!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    trackClick (e) {
      window.analytics.track('Send Mail')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ContactAddress.vue